<template>
  <section>
    <el-row class="warp">
      <el-col :span="6" class="warp-breadcrum">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/resultMng/journalData' }">
              <b>卷期列表</b>
            </el-breadcrumb-item>
            <el-breadcrumb-item>整期数据上传详情列表</el-breadcrumb-item>
          </el-breadcrumb>
      </el-col>
      <el-col :span="6">
        <el-button type="primary" size="small" @click="back(null)">返回</el-button>
      </el-col>
    </el-row>  
    <el-row class="warp">
      <el-descriptions class="margin-top" :column="3" border>
          <el-descriptions-item label="期刊名称">
              <template slot="label"><i class="el-icon-tickets"></i>期刊名称</template>
              {{this.searchForm.journalName}}
          </el-descriptions-item>
          <el-descriptions-item label="年">
              <template slot="label"><i class="el-icon-tickets"></i>年份</template>
              {{this.searchForm.year}}
          </el-descriptions-item>
      </el-descriptions>
    </el-row>
      <!--工具条 begin-->
    <el-row class="warp">
      <!-- 列表显示 begin-->
      <el-col :span="24" class="tablebar" style="padding-bottom: 0px;">
        <el-table :data="issueInfoList" style="width: 100%;overflow: auto;" stripe border highlight-current-row v-loading="pageLoading" element-loading-text="重试发布中"
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <!-- 第一行显示数据 -->
          <el-table-column
            type="index"
            width="50">
          </el-table-column>
          <el-table-column prop="id" label="Id" key="1" sortable align="center"></el-table-column>
          <el-table-column prop="dataName" label="文章名称" key="2" sortable align="center"></el-table-column>
          <el-table-column prop="uploadTime" label="上传时间" key="3" sortable align="center"></el-table-column>
          <el-table-column prop="transStatus" label="转换状态"  key="4" sortable align="center">
              <template slot-scope="scope">
                <el-tag
                    :type="scope.row.transStatus === 1 ? 'success' : 'danger'"
                    disable-transitions>
                    {{scope.row.transInfo}}
                </el-tag>
              </template>
          </el-table-column>
          <el-table-column prop="pubStatus" label="发布状态" key="5" sortable align="center">
            <template slot-scope="scope">
                <el-tag
                    :type="scope.row.pubStatus === 1 ? 'success' : 'danger'"
                    disable-transitions>
                    {{scope.row.pubInfo}}
                </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="auditStatus" label="审核状态" v-if="isAudit" key="6" sortable align="center">
            <template slot-scope="scope">
                <el-tag
                    :type="scope.row.auditStatus === 1 ? 'success' : 'danger'"
                    disable-transitions>
                    {{scope.row.auditInfo}}
                </el-tag>
            </template>
          </el-table-column>
          <!-- 上传按钮 -->
          <el-table-column label="上传" key="7" width="240" align="center">
            <template slot-scope="scope">
              <el-upload
                  class="upload-demo"
                  ref="upload"
                  :action="packageUrl(scope.row)"
                  accept="zip"
                  :limit="1"
                  :file-list="fileList"
                  :on-success="uploadApkSuccess"
                  :before-upload="beforeUpload"
                  >
                  <el-button size="small" type="success">覆盖上传</el-button>
              </el-upload>
            </template>
          </el-table-column>
          <!-- 操作按钮 -->
          <el-table-column label="操作"  key="8" width="240" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="downLoad(scope.$index, scope.row)">下载</el-button>
              <el-button type="primary" size="mini" :style="(scope.row.pubStatus === 0 && scope.row.transStatus ===1) ? { display: '' } : { display: 'none' }" @click="retry(scope.$index, scope.row)">重试</el-button>
              <el-button type="primary" size="mini" :style="(scope.row.pubStatus === 1 && scope.row.auditStatus !==2) ? { display: '' } : { display: 'none' }" @click="skip(scope.$index, scope.row)">跳转</el-button>
              <el-button type="danger" size="mini" :style="(scope.row.auditStatus === 2) ? { display: '' } : { display: 'none' }" @click="showReason(scope.row)">反馈</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!-- 列表显示 end-->
    </el-row>
  </section>
</template>

<script>
import API_LOG from "../../../api/api_log";
import API_JOURNALDATA from "../../../api/api_journalData";
export default {
    data() {
        return {
            searchForm:{
                journalName:"",
                year:"",
                journalId:"",
                issue:"",
                audit:'',
            },
            issueInfoList: [],
            //页面载入状态
            pageLoading: false,
            isAudit:false,
            fileList: [],
        //在此添加新的数据定义
        };
    },
    created(){
        this.dataInit();
        this.getIssueInfoList();
    },
    mounted() {
        
    },

    methods: {
        dataInit(){
            let that = this;
            that.searchForm.journalName = this.$route.query.journalName;
            that.searchForm.year = this.$route.query.year;
            that.searchForm.journalId = this.$route.query.journalId;
            that.searchForm.issue = this.$route.query.issue;
            that.searchForm.audit = this.$route.query.audit;
            var a = this.$route.query.audit;
            console.log("......dataInit isAudit:" + this.$route.query.audit);
            if(a === 'true'){
              that.isAudit = true;
            }
            else{
              that.isAudit = false;
            }
        },

        getIssueInfoList(){
            let that = this;
            let params = {
                yearValue: that.searchForm.year,
                journalId: that.searchForm.journalId,
                issue: that.searchForm.issue
            };
            console.log("......getIssueInfoList params:" + JSON.stringify(params));
            //发送http请求
            API_JOURNALDATA.getIssueInfoList(params)
            .then(res => {
                if(res && res.issueInfoList){
                    that.issueInfoList = Object.values(res.issueInfoList);
                    console.log(
                        "......getIssueInfoList:" + JSON.stringify(that.issueInfoList)
                    );
                }
            })
            .catch(e => {
                this.$message({
                    showClose: true,
                    type: "error",
                    message: "请求出现异常",
                    duration: 2000
                });
            });
        },

        packageUrl(row)
        {
          //debugger;
          return  "api/journalData/singleFileUpload?infoId="+row.id;
        },

        beforeUpload(){
          this.pageLoading = true;
        },

        submitUpload() {
          this.$refs.upload.submit();
        },

        back(){
          this.$router.push({path: '/resultMng/journalData', query: {yearValue: this.searchForm.year, journalId: this.searchForm.journalId}})
        },

        downLoad: function(index, row) {
          console.log("........downLoad:" + JSON.stringify(row));
          let that = this;
          let params = {
            transUrl: row.dataPath
          };
          API_LOG.downloadZip(params)
            .then(res => {
              if (navigator.userAgent.match(/MSIE\s([\d.]+)/) ||navigator.userAgent.indexOf("Trident") > -1) {
                    window.navigator.msSaveBlob(res, row.dataName);
              } 
              else {
                const blob = new Blob([res]);
                const fileName = row.dataName;
                let url = window.URL.createObjectURL(blob);
                let link = document.createElement('a');
                link.style.display = 'none';
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
              }
            })
            .catch(e => {
              this.$message({
                showClose: true,
                type: "error",
                message: "请求出现异常",
                duration: 2000
              });
            });
        },

        skip: function(index, row) {
          console.log("........skip:" + JSON.stringify(row));
          let href = row.pubUrl;
          console.log("........skip:" + href);
          window.open(href, '_blank');
        },

        retry: function(index, row){
          let params = {
            id: row.id
          };
          this.pageLoading = true;
          API_JOURNALDATA.retryPub(params)
            .then(res => {
              if(res){
                if(res.errorCode === 0){
                    console.log(
                        "......retry:" + JSON.stringify(res)
                    );
                }
                else{
                   this.$message({
                    showClose: true,
                    type: "error",
                    message: res.errorInfo,
                    duration: 2000
                });
                }
              }
              this.pageLoading = false;
              this.getIssueInfoList();
            })
            .catch(e => {
                this.$message({
                    showClose: true,
                    type: "error",
                    message: "请求出现异常",
                    duration: 2000
                });
                this.pageLoading = false;
                this.getIssueInfoList();
            });
            
        },

        uploadApkSuccess(response, fileList) {
          console.log('response ----> ',response);
          console.log('fileList ----> ',fileList);
          if(response.errorCode != 0)
          {
              this.$message({
              showClose: true,
              type: "info",
              message: response.errorInfo,
              duration: 2000
            });
            this.fileList= [];
            this.pageLoading = false;
            return;
          }
          else{
            this.fileList= [];
            this.getIssueInfoList();
            this.pageLoading = false;
          }
        },

        showReason(row){
            this.$alert(
            row.auditRejectInfo, 
            '问题反馈', 
            {
                confirmButtonText: '确定',
            });
        }
    }
}
</script>

<style scoped>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>


// WEBPACK FOOTER //
// src/views/SysMng/Data/DataManageInfo.vue